






























































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { ProductCategory, ProductItem } from '@/types';
import { ContractLink } from '@/components/Shared';
import ProductIconName from '@/components/Shared/ProductIconName';
import ProductSupportLink from '@/components/Shared/ProductSupportLink';
import ProductDetails from '@/components/ProductDetails/ProductDetails.vue';
import ProductHistory from '@/components/ProductHistory/ProductHistory.vue';
import TriangleDownIcon from '@/assets/icons/icn-triangle-down.svg';

import { ProductList, ProductListHeader, ProductListItems, } from '@/components/ProductCategoryMobile/ProductList';

@Component({
  components: {
    ContractLink,
    ProductList,
    ProductListHeader,
    ProductListItems,
    ProductIconName,
    ProductSupportLink,
    ProductDetails,
    ProductHistory,
    TriangleDownIcon,
  },
})
export default class ProductCategoryDrones extends Vue {
  @Getter public drones: ProductCategory<ProductItem>;

  public getProductHistory(product: ProductItem) {
    this.$store.dispatch('fetchProductHistory', product);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProductCategoryMobile/Drones/ProductCategoryDrones.vue